module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_toyama-1cc2ae3f7af4277263fdd841a591d78b.png";